import React, { useContext, useState } from "react";
import { ListGroup, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";

import ChatList from "./ChatList";
import { ConfigContext } from "../../../../contexts/ConfigContext";
import { useGlobalValues } from "../../../../contexts/globalValues";
import useAuth from "../../../../hooks/useAuth";

import defultProfile from "../../../../assets/images/user/userDefault.png";
import PrinterConfig from "../../../../views/configuration/printerConfig";

const NavRight = () => {
  const configContext = useContext(ConfigContext);
  const { selectedSucursal, setSelectedSucursal } = useGlobalValues();
  const { logout, user } = useAuth();
  const { rtlLayout } = configContext.state;
  const [listOpen, setListOpen] = useState(false);
  const globalValues = JSON.parse(localStorage.getItem("globalValues"));
  const sucursales = globalValues?.sucursales;
  const [notificaciones] = useState([]);

  const align = !rtlLayout ? "end" : "start";
  const tienda = sucursales ? sucursales[0]?.nombre : "";

  const handleLogout = async () => {
    try {
      await logout();
    } catch (err) {
      console.error(err);
    }
  };

  const changeSucursal = (id) => {
    const infoSuc = sucursales?.find((item) => item.id_sucursal === id);
    setSelectedSucursal({
      id_sucursal: id !== 0 ? infoSuc.id_sucursal : 0,
      sucursal: id !== 0 ? infoSuc.sucursal : "Todas",
    });
  };

  return (
    <React.Fragment>
      <ListGroup as="ul" bsPrefix=" " className="navbar-nav ml-auto">
        {tienda ? (
          <ListGroup.Item as="li" bsPrefix=" ">
            <span className="kn-chip kn-chip--store">
              <i className="feather icon-shopping-bag" aria-hidden="true" />
              {tienda}
            </span>
          </ListGroup.Item>
        ) : null}

        <ListGroup.Item as="li" bsPrefix=" ">
          <Dropdown align={align}>
            <Dropdown.Toggle as="button" type="button" className="kn-chip" aria-label="Cambiar sucursal">
              <i className="feather icon-map-pin" aria-hidden="true" />
              {selectedSucursal?.sucursal}
              <i className="feather icon-chevron-down kn-caret" aria-hidden="true" />
            </Dropdown.Toggle>
            <Dropdown.Menu style={{ minWidth: 220 }}>
              <div className="kn-dd-title">Sucursal</div>
              <PerfectScrollbar style={{ maxHeight: 280 }}>
                {sucursales?.length > 1 ? (
                  <Dropdown.Item
                    active={selectedSucursal?.id_sucursal === 0}
                    onClick={() => changeSucursal(0)}
                  >
                    <i className="feather icon-layers" aria-hidden="true" /> Todas
                  </Dropdown.Item>
                ) : null}
                {sucursales?.map((item) => (
                  <Dropdown.Item
                    key={item.id_sucursal}
                    active={selectedSucursal?.id_sucursal === item.id_sucursal}
                    onClick={() => changeSucursal(item.id_sucursal)}
                  >
                    <i className="feather icon-map-pin" aria-hidden="true" /> {item.sucursal}
                  </Dropdown.Item>
                ))}
              </PerfectScrollbar>
            </Dropdown.Menu>
          </Dropdown>
        </ListGroup.Item>

        <ListGroup.Item as="li" bsPrefix=" ">
          <Dropdown align={align}>
            <Dropdown.Toggle as="button" type="button" className="kn-icon-btn" aria-label="Impresoras">
              <i className="feather icon-printer" aria-hidden="true" />
            </Dropdown.Toggle>
            <Dropdown.Menu style={{ width: 340 }}>
              <div className="kn-dd-title">Configuración de impresoras</div>
              <PerfectScrollbar style={{ maxHeight: 360 }}>
                <div style={{ padding: "4px 8px" }}>
                  <PrinterConfig />
                </div>
              </PerfectScrollbar>
              <div className="kn-dd-sep" />
              <Link to="/config/printer" className="kn-dd-footer">
                Ir a configuración
              </Link>
            </Dropdown.Menu>
          </Dropdown>
        </ListGroup.Item>

        {user?.role === "Administrador" ? (
          <ListGroup.Item as="li" bsPrefix=" ">
            <Dropdown align={align}>
              <Dropdown.Toggle as="button" type="button" className="kn-icon-btn" aria-label="Notificaciones">
                <i className="feather icon-bell" aria-hidden="true" />
                {notificaciones.length > 0 ? <span className="kn-dot" /> : null}
              </Dropdown.Toggle>
              <Dropdown.Menu style={{ width: 340 }}>
                <div className="kn-dd-title">Notificaciones</div>
                <PerfectScrollbar style={{ maxHeight: 360 }}>
                  {notificaciones.length === 0 ? (
                    <div className="kn-empty">No tienes notificaciones nuevas</div>
                  ) : (
                    notificaciones.map((noti, i) => (
                      <div key={noti.id ?? i} className="dropdown-item" style={{ alignItems: "flex-start" }}>
                        <i className="feather icon-bell" aria-hidden="true" style={{ marginTop: 3 }} />
                        <div>
                          <b style={{ display: "block" }}>{noti.titulo}</b>
                          <span style={{ fontSize: 13 }}>{noti.mensaje}</span>
                          <small style={{ display: "block", opacity: 0.6, marginTop: 4 }}>
                            {noti.fecha_creacion}
                          </small>
                        </div>
                      </div>
                    ))
                  )}
                </PerfectScrollbar>
              </Dropdown.Menu>
            </Dropdown>
          </ListGroup.Item>
        ) : null}

        {user?.role === "superUser" ? (
          <ListGroup.Item as="li" bsPrefix=" ">
            <button
              type="button"
              className="kn-icon-btn displayChatbox"
              aria-label="Mensajes"
              onClick={() => setListOpen(true)}
            >
              <i className="feather icon-mail" aria-hidden="true" />
              <span className="kn-dot" />
            </button>
          </ListGroup.Item>
        ) : null}

        <ListGroup.Item as="li" bsPrefix=" ">
          <Dropdown align={align} className="drp-user">
            <Dropdown.Toggle as="button" type="button" className="kn-user" aria-label="Menú de usuario">
              <img src={user?.image || defultProfile} alt="" />
              <span className="kn-user__info">
                <span className="kn-user__name">{user?.name || ""}</span>
                <span className="kn-user__role">{user?.role || ""}</span>
              </span>
            </Dropdown.Toggle>
            <Dropdown.Menu style={{ width: 260 }}>
              <div className="kn-dd-head">
                <img src={user?.image || defultProfile} alt="" />
                <div>
                  <b>{user?.name || ""}</b>
                  <span>{user?.role || ""}</span>
                </div>
              </div>
              <Dropdown.Item as={Link} to="/config/profile-view">
                <i className="feather icon-user" aria-hidden="true" /> Perfil
              </Dropdown.Item>
              <Dropdown.Item as={Link} to="#">
                <i className="feather icon-mail" aria-hidden="true" /> Mis mensajes
              </Dropdown.Item>
              <div className="kn-dd-sep" />
              <Dropdown.Item as="button" className="kn-dd-danger" onClick={handleLogout}>
                <i className="feather icon-log-out" aria-hidden="true" /> Cerrar sesión
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </ListGroup.Item>
      </ListGroup>
      <ChatList listOpen={listOpen} closed={() => setListOpen(false)} />
    </React.Fragment>
  );
};

export default NavRight;
